export default __webpack_public_path__ + "static/media/cp_geo_es.9022b6f1.svg";